<ng-content></ng-content>
<div class="overlay" (click)="select()">
	{{key | questionLabel}}
</div>